import React from 'react';

import Copyright from 'components/Copyright';
import FooterSocial from 'components/FooterSocial';

import ImageAppStore from 'images/app-store-badge.svg';
import ImagePlayStore from 'images/google-play-badge.svg';
import ImageLogo from 'images/logo.svg';

import {
  Badge,
  ClearFix,
  Column,
  Container,
  LearnMore,
  List,
  ListItem,
  ListLink,
  Logo,
  LogoBlock,
  MobileBadges,
  Row,
  SmallColumn,
  Title,
  Wrapper,
} from 'components/FooterStyles';

const Footer = () => (
  <>
    <Wrapper>
      <Container>
        <Row>
          <SmallColumn>
            <Title>Learn</Title>

            <List>
              <ListItem>
                <ListLink href="/courses">Courses</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/tracks/skill">Skill Tracks</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/tracks/career">Career Tracks</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/pricing">Pricing</ListLink>
              </ListItem>
              <ListItem>
                {' '}
                <ListLink href="/create">Become an Instructor</ListLink>
              </ListItem>
            </List>
          </SmallColumn>

          <SmallColumn>
            <Title>Resources</Title>

            <List>
              <ListItem>
                <ListLink href="/resources/">Resource Center</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/community/">Community</ListLink>
              </ListItem>
              <ListItem>
                <ListLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.rdocumentation.org"
                >
                  RDocumentation
                </ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/teach/">Course Editor</ListLink>
              </ListItem>
              <ListItem>
                <ListLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://trello.com/b/BLplifUB/datacamp-course-roadmap"
                >
                  Upcoming Courses
                </ListLink>
              </ListItem>
              <ListItem>
                <ListLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://support.datacamp.com"
                >
                  Support
                </ListLink>
              </ListItem>
            </List>
          </SmallColumn>

          <ClearFix />

          <SmallColumn>
            <Title>Plans</Title>

            <List>
              <ListItem>
                <ListLink href="/groups/business">For Business</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/groups/education">For Classrooms</ListLink>
              </ListItem>
            </List>
          </SmallColumn>

          <SmallColumn>
            <Title>About</Title>

            <List>
              <ListItem>
                <ListLink href="/stories">Stories</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/careers">Careers</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="https://support.datacamp.com/hc/en-us/articles/360021185634">
                  Contact
                </ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/brand">Press</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="mailto:partnerships@datacamp.com?subject=Become%20a%20Partner">
                  Become a Partner
                </ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/privacy-policy">Privacy Policy</ListLink>
              </ListItem>
              <ListItem>
                <ListLink href="/terms-of-use">Terms of Use</ListLink>
              </ListItem>
            </List>
          </SmallColumn>

          <Column>
            <LogoBlock>
              <Logo src={ImageLogo} alt="Logo full filled white" />
            </LogoBlock>

            <p>
              DataCamp offers interactive R, Python, Sheets, SQL and shell
              courses. All on topics in data science, statistics and machine
              learning. Learn from a team of expert teachers in the comfort of
              your browser with video lessons and fun coding challenges and
              projects.
            </p>
            <LearnMore href="/about">About the company</LearnMore>

            <FooterSocial className="dc-u-mt-32" />
          </Column>
        </Row>

        <MobileBadges>
          <Badge
            target="_blank"
            rel="noopener noreferrer"
            href="https://itunes.apple.com/us/app/datacamp-learn-r-python/id1263413087"
          >
            <img src={ImageAppStore} alt="App store badge" />
          </Badge>

          <Badge
            target="_blank"
            rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=com.datacamp"
          >
            <img src={ImagePlayStore} alt="Play store badge" />
          </Badge>
        </MobileBadges>
      </Container>
    </Wrapper>
    <Copyright />
  </>
);

export default Footer;
